var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "transparent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C6.24935 4 4 6.24935 4 9C4 11.7507 6.24935 14 9 14C11.7506 14 14 11.7507 14 9C14 6.24935 11.7506 4 9 4ZM9 5.66667C10.8522 5.66667 12.3333 7.14779 12.3333 9C12.3333 10.8522 10.8522 12.3333 9 12.3333C7.14779 12.3333 5.66667 10.8522 5.66667 9C5.66667 7.14779 7.14779 5.66667 9 5.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.20732C13 3.81402 13.314 3.5 13.7073 3.5C14.1006 3.5 14.4146 3.81402 14.4146 4.20732C14.4146 4.60061 14.1006 4.91463 13.7073 4.91463C13.314 4.91463 13 4.60061 13 4.20732Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2H5C3.34315 2 2 3.34315 2 5V13C2 14.6569 3.34315 16 5 16H13C14.6569 16 16 14.6569 16 13V5C16 3.34315 14.6569 2 13 2ZM5 0C2.23858 0 0 2.23858 0 5V13C0 15.7614 2.23858 18 5 18H13C15.7614 18 18 15.7614 18 13V5C18 2.23858 15.7614 0 13 0H5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8109fa6cf1b2fafef1031b6cbed09579.svg";
export { ForwardRef as ReactComponent };